/* eslint-disable react/jsx-no-useless-fragment */
import CopyButton from 'components/common/copy/CopyButton';
import FormControl from 'components/common/form-control/FormControl';
import { ICON } from 'constants/icons';
// import { ICON } from 'constants/icons';
import useQrDownload from 'hooks/feature/tenant/share/useQrDownload';
import { MouseEvent } from 'react';
import { Workspace } from 'types/feature/workspace/workspace';

type Props = {
  workspace: Workspace;
};

const MobileUrl = ({ workspace }: Props) => {
  const { downQrImage } = useQrDownload();

  const mobileUrl = workspace.mobileEndpoint;

  const onClickDownload = (e: MouseEvent) => {
    e.stopPropagation();

    if (!workspace) {
      return;
    }

    // 일반 워크스페이스는 바로 QR 다운로드 받는다
    downQrImage(`${workspace.name}-매장 위치 확인`, mobileUrl);
  };

  return (
    <>
      <FormControl
        labelSize={100}
        name='모바일 URL'
        control={
          <section className='flex items-center w-full h-9'>
            {/* url */}
            <div className='text-[14px] w-[380px] break-words line-clamp-1'>{mobileUrl}</div>

            {/* buttons */}
            <div className='flex items-center gap-[10px] shrink-0'>
              <div className='cursor-pointer' onClick={onClickDownload}>
                <img src={ICON.DOWNLOAD_BUTTON} alt='다운로드' className='h-full' />
              </div>

              {/* 복사 버튼 */}
              <CopyButton text={mobileUrl} />
            </div>
          </section>
        }
      />
    </>
  );
};

export default MobileUrl;
